import React, { useState, useEffect } from 'react';
import { UpgradePlanModal } from './UpgradePlanModal';
import { FeatureKey } from '@/services/billingApi';

export const GlobalPlanUpgradeModal: React.FC = () => {
  const [modalState, setModalState] = useState<{
    isOpen: boolean;
    feature?: FeatureKey;
    title?: string;
    description?: string;
    requiredPlan?: string;
    actionLabel?: string;
  }>({
    isOpen: false,
  });

  useEffect(() => {
    const handlePlanRestricted = (event: Event) => {
      const customEvent = event as CustomEvent;
      const detail = customEvent.detail;
      const featureKey: FeatureKey | undefined = detail?.details?.feature;
      const requiredPlan = detail?.details?.requiredPlan?.name;

      setModalState({
        isOpen: true,
        feature: featureKey,
        requiredPlan,
        title: detail?.error || 'Plan Upgrade Required',
        description:
          detail?.error ||
          'Your current plan does not include access to this tool. Upgrade your subscription to continue.',
        actionLabel: 'Upgrade Plan',
      });
    };

    const handleSubscriptionInactive = (event: Event) => {
      const customEvent = event as CustomEvent;
      const detail = customEvent.detail;

      setModalState({
        isOpen: true,
        title: 'Account in Read-Only Mode',
        description:
          detail?.error ||
          'Your subscription is inactive or past due. Write operations are restricted until billing is reactivated.',
        actionLabel: 'Reactivate Subscription',
      });
    };

    window.addEventListener('billing:plan-restricted', handlePlanRestricted);
    window.addEventListener('billing:subscription-inactive', handleSubscriptionInactive);

    return () => {
      window.removeEventListener('billing:plan-restricted', handlePlanRestricted);
      window.removeEventListener('billing:subscription-inactive', handleSubscriptionInactive);
    };
  }, []);

  return (
    <UpgradePlanModal
      isOpen={modalState.isOpen}
      onClose={() => setModalState((prev) => ({ ...prev, isOpen: false }))}
      feature={modalState.feature}
      title={modalState.title}
      description={modalState.description}
      requiredPlan={modalState.requiredPlan}
      actionLabel={modalState.actionLabel}
    />
  );
};

export default GlobalPlanUpgradeModal;
